// ClientApp/src/apps/components/tests/SsoAuthVerificationFlow/hooks/useNiogemsAuthStatus.js
import { useMemo } from "react";
import {
  parseNiogemsPayload,
  isNiogemsApproved,
  isNiogemsDenied,
} from "../utils/niogemsPayload";

/**
 * Derives approved/denied status and parsed payload data from a raw
 * niogemsAuth response object. Memoized so the parse work only re-runs
 * when niogemsAuth actually changes.
 *
 * @param {object|null} niogemsAuth - raw response from fetchNiogemsToken
 * @returns {{ approved: boolean, denied: boolean, parsedPayload: object|null }}
 */
export function useNiogemsAuthStatus(niogemsAuth) {
  return useMemo(() => {
    const approved = isNiogemsApproved(niogemsAuth);
    const denied = isNiogemsDenied(niogemsAuth);
    const parsedPayload = approved ? parseNiogemsPayload(niogemsAuth?.message) : null;

    return { approved, denied, parsedPayload };
  }, [niogemsAuth]);
}